module.exports = __webpack_public_path__ + "static/media/5.2afc8811.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/5.png
// module id = 254
// module chunks = 0